import { defineComponent } from "vue";
import { TournamentTeamListing }  from "./TournamentTeamListing";

export default defineComponent({
  setup() {
    return () => <TournamentTeamListing mode="registrant"/>
  }
})
